/*
 * @Descripttion: 创新产品
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-20 14:48:37
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2026-10-29 11:53:34
 */
const product = {
  skull: {
    processImg: require('@/assets/images/pc/innovate/en/skull_process.png'),
    m_processImg: require('@/assets/images/m/innovate/en/skull_process.png'),
    intelligence: {
      title: ['For Aneurysm'],
      des: ['The incidence of intracranial aneurysms is as high as 7% in the population, yet the risk of rupture is less than 1%. The precise assessment of the risk of rupture and treatment has become a significant problem for clinicians.', 'The intracranial aneurysm intelligent diagnosis and treatment series products assist doctors in completing diagnosis and treatment, significantly improve the early detection rate of cerebrovascular disease, enhance treatment effectiveness and reduce mortality and costs.'],
      img: require('@/assets/images/pc/innovate/en/skull_intelligence.png'),
      m_img: require('@/assets/images/m/innovate/en/skull_intelligence.png')
    },
    coreAdvantages: {
      title: 'Core Advantages',
      des: [
        '100+ institution partners, including Changhai Hospital, Shanghai Huashan Hospital of FUDAN University, Beijing Tiantan Hospital, The Second Affiliated Hospital of Zhejiang University School of Medicine, etc',
        '100+ SCI articles published on famous cerebrovascular disease journals, including Stroke, AJNR, and JNS',
        'Dozens of in-depth research cooperations with numerous articles and projects'],
      img: require('@/assets/images/pc/innovate/skull_advantages_bj.png'),
      list: [
        {
          title: 'Accurate',
          des: 'Updating diagnosis methods',
          img: require('@/assets/images/innovate/icons/6.png')
        }, {
          title: 'Safe',
          des: 'Improving interventional results',
          img: require('@/assets/images/innovate/icons/13.png')
        }, {
          title: 'Economical',
          des: 'Reducing waste of consumables and patients’ expenses',
          img: require('@/assets/images/innovate/icons/9.png')
        }, {
          title: 'Personalized',
          des: 'Bringing better treatment experience to patients and clinicians',
          img: require('@/assets/images/innovate/icons/14.png')
        }
      ]
    },
    relatedProducts: {
      title: 'Products',
      list: [
        {
          path: '/en/innovative/intracranial/aneuflow',
          title: 'AneuFlow | Preoperative Hemodynamic assessment',
          img: require('@/assets/images/innovate/en/aneuflow.png')
        }, {
          path: '/en/innovative/intracranial/aneuguide',
          title: 'AneuGuide | Intraoperative Interventional Planning',
          img: require('@/assets/images/innovate/en/aneuguide.png')
        }, {
          path: '/en/innovative/intracranial/aneushape',
          title: 'AneuShape | Intraoperative Microcatheter Shaping',
          img: require('@/assets/images/innovate/aneushape.png')
        }, {
          path: '/en/innovative/intracranial/aneuplan',
          title: 'AneuPlan | Preoperative Planning',
          img: require('@/assets/images/innovate/aneuplan.png')
        }
      ]
    },
    stroke: {
      title: 'For Stroke',
      des: [
        "Stroke is gradually becoming the world's No.1 killer. Stroke, including infarction and hemorrhage, is a cerebrovascular disease with high risk of incidence, disability, death and recurrence.",
        'The complete solution for stroke is lunched to assists doctors in diagnosis and provides support for clinical treatment decisions.'
      ],
      bjImg: require('@/assets/images/pc/innovate/skull_stroke.png'),
      bjImgM: require('@/assets/images/m/innovate/skull_stroke.png'),
      summary: {
        img: require('@/assets/images/pc/innovate/skull_stroke_summary.png'),
        des: [
          'Intelligent • Lightweight • Accurate • Real-time',
          'Complete Solution For Stroke',
          'Solution for ischemic stroke assessment over time window and saving live'
        ]
      },
      list: [
        'Diagnosis, treatment and research – comprehensively improving the capabilities of the hospital departments',
        'Covering the whole treatment process to improve the safety of surgery',
        'Establishing special outpatient clinics to increase the number of stroke clinics in hospitals',
        'Assisting the research of the department and participating in multi-center projects',
        'Improving the popularity and reputation of the stroke centers',
        'Promoting the construction of wise medical & wise city'
      ],
      products: {
        title: 'Products',
        list: [
          {
            path: '/en/innovative/intracranial/accuaspects',
            title: 'AccuASPECTS | Automated Calculation of ASPECTS',
            img: require('@/assets/images/innovate/accuaspects.png')
          }, {
            path: '/en/innovative/intracranial/accuctp',
            title: 'AccuCTP | Cerebral Perfusion Analysis',
            img: require('@/assets/images/innovate/en/accuctp.png')
          }
        ]
      }
    },
    narrow: {
      title: ['For ICAS'],
      des: 'Intracranial atherosclerosis disease (ICAS) has two-year stroke recurrence rate as high as 25% ~ 30%. At present, the high risk of ICAS is determined solely by the high stenosis rate (>70%). Studies have shown that 40% of recurrent stroke occurs in patients with a stenosis rate of 40%-69%. Severe stenosis can also reduce the risk of stroke recurrence due to the opening of collateral circulation. Therefore, it is necessary to increase functional assessment methods other than morphology for vascular stenosis.',
      bjImg: require('@/assets/images/pc/innovate/skull_narrow_bj.png'),
      MbjImg: require('@/assets/images/m/innovate/skull_narrow_bj.png'),
      summary: {
        img: require('@/assets/images/pc/innovate/skull_narrow_summary.png'),
        des: [
          '3D reconstruction',
          'Stenosis quantification',
          'Multi-dimensional functional assessment'
        ]
      },
      list: [
        "AccuICAS, the highly adaptable complete solution for ICAS, can process patients' personalized information with medical images, and evaluate the intracranial vascular function quickly and accurately."
      ],
      products: {
        title: 'Products',
        list: [
          {
            path: '/en/innovative/intracranial/accuicas',
            title: 'AccuICAS | ICAS Functional Assessment',
            img: require('@/assets/images/innovate/en/accuffr_icas.png')
          }
        ]
      }
    }
  },
  heart: {
    processImg: require('@/assets/images/pc/innovate/en/heart_process.png'),
    m_processImg: require('@/assets/images/m/innovate/en/heart_process.png'),
    intelligence: {
      title: 'AccuFFR, Intelligent Diagnosis and Treatment Solutions',
      des: 'ArteryFlow has launched a series of multimodal FFR coronary stenosis assessment products based on coronary CT, coronary angiography, IVUS, and OCT. These products cover the entire process from intelligent diagnosis to personalized treatment of coronary heart disease. With improved computational efficiency powered by AI deep learning, these products help to promote accurate and intelligent diagnosis and treatment of cardiovascular disease in clinical practice.',
      img: require('@/assets/images/pc/innovate/heart_intelligence.png'),
      m_img: require('@/assets/images/m/innovate/heart_intelligence.png')
    },
    coreAdvantages: {
      title: 'Product Advantages',
      list: [
        {
          title: 'Patients',
          des: [
            'Diagnostic accuracy was improved by 33% compared with conventional angiography',
            'Reduce major adverse cardiac events after PCI by 20%',
            "The patient's quality of life after PCI was improved significantly"
          ],
          img: require('@/assets/images/innovate/icons/heart_list_1.png')
        }, {
          title: 'Operative',
          des: [
            'Shorten X-ray time significantly',
            'Provide intuitive evidence-supported medical reports',
            'Assist clinical diagnosis and treatment with multi-modality in the same platform'
          ],
          img: require('@/assets/images/innovate/icons/heart_list_2.png')
        }, {
          title: 'Department',
          des: [
            'No consumable  Reduce consumption',
            'Standard quality control for noninvasive functional coronary interventions',
            'Clinical application of pioneering technology with artificial intelligence and hemodynamics'
          ],
          img: require('@/assets/images/innovate/icons/heart_list_3.png')
        }
      ]
    },
    relatedProducts: {
      title: 'Products',
      list: [
        {
          path: '/en/innovative/intracardiac/accuffrct',
          title: 'AccuFFRct | CTA-derived Non-invasive FFR',
          img: require('@/assets/images/innovate/accuffr_ct.png')
        }, {
          path: '/en/innovative/intracardiac/accuffrangio',
          title: 'AccuFFRangio | Angiography-derived FFR',
          img: require('@/assets/images/innovate/accuffr_angio.png')
        }, {
          path: '/en/innovative/intracardiac/accuffrivus',
          title: 'AccuFFRivus | IVUS-derived FFR',
          img: require('@/assets/images/innovate/accuffr_ivus.png')
        }, {
          path: '/en/innovative/intracardiac/accuffroct',
          title: 'AccuFFRoct | OCT-derived FFR',
          img: require('@/assets/images/innovate/accuffr_oct.png')
        }
      ]
    },
    structureFunction: {
      title: 'More products',
      des: "ArteryFlow's intelligent diagnosis products for cardiac structural and functional assessment can automatically perform heart segmentation, coronary artery segmentation, centerline extraction, plaque detection and classification, and ventricular bullseye plot analysis. It can quickly generate structured reports and screen patients with potential cardiac functional abnormalities, to help doctors improve workflow with our industry-leading high efficiency and highly automatic process.",
      img: require('@/assets/images/innovate/en/heart_structureFunction.png'),
      bjImg: require('@/assets/images/innovate/heart_structureFunction_bj.png'),
      summary: {
        img: require('@/assets/images/pc/innovate/en/heart_structureFunction_summary.png'),
        imgM: require('@/assets/images/m/innovate/en/heart_structureFunction_summary.png'),
        bjImg: require('@/assets/images/innovate/heart_structureFunction_summary_bj.png')
      },
      products: {
        title: 'Products',
        list: [
          {
            path: '/en/innovative/intracardiac/acculv',
            title: 'AccuLV | Non-invasive Cardiac Functional assessment',
            img: require('@/assets/images/innovate/acculv.png')
          }, {
            path: '/en/innovative/intracardiac/accuimr',
            title: 'AccuIMR | Microcirculation assessment',
            img: require('@/assets/images/innovate/accu_imr.png')
          }
        ]
      }
    },
    significance: {
      img: require('@/assets/images/pc/innovate/en/heart_significance.png'),
      imgM: require('@/assets/images/m/innovate/en/heart_significance.png')
    }
  },
  aneuflow: {
    title: '<i class="p-r-6">AneuFlow</i> | Intracranial Aneurysm Hemodynamic Assessment',
    name: '脑血管智能诊疗解决方案',
    type: 'AneuFlow',
    list: [
      {
        title: 'Clinical Applications',
        des: [
          'AneuFlow evaluates aneurysms with morphological, hemodynamic and clinical characteristics. With a multi-dimensional assessment, AneuFlow provides a multi-dimensional reference for clinical treatment decisions.',
          'Approved by CN NMPA.'
        ],
        img: require('@/assets/images/innovate/AneuFlow/en/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: 'Fast hemodynamic analysis',
            list: [
              'Fast assessment calculations based on morphological and hemodynamic information of the aneurysm',
              'Multi-model image compatibility (including 3D DSA, CTA and MRA)'
            ]
          }, {
            title: 'Accurate intracranial aneurysm assessment',
            list: [
              'Accurate assessment of aneurysms using machine learning model',
              'Multi-dimensional assessment rather than just size > 7mm'
            ]
          }
        ],
        img: require('@/assets/images/innovate/AneuFlow/2.png')
      }, {
        title: 'Advantages',
        des: [
          {
            title: 'Only hemodynamic product approved by CN NMPA'
          }, {
            title: 'Complete analysis within 10 minutes'
          }, {
            title: 'All types of aneurysms covered'
          }, {
            title: 'The largest aneurysm hemodynamic database in the world'
          }
        ],
        img1: require('@/assets/images/innovate/AneuFlow/en/3.png'),
        img2: require('@/assets/images/innovate/AneuFlow/en/4.png'),
        m_img1: require('@/assets/images/innovate/AneuFlow/en/m_4.png')
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Xiang J, Natarajan SK, Tremmel M, et al. Hemodynamic–Morphologic Discriminants for Intracranial Aneurysm Rupture. Stroke 2011; 42: 144–152',
        'Xiang J, Yu J, Choi H, et al. Rupture Resemblance Score (RRS): toward risk stratification of unruptured intracranial aneurysms using hemodynamic–morphological discriminants. J NeuroIntervent Surg 2015; 7: 490–495'
      ]
    }
  },
  aneuplan: {
    title: '<i class="p-r-6">AneuPlan</i> | Intracranial Aneurysm Preoperative Planning',
    name: '脑血管智能诊疗解决方案',
    type: 'AneuPlan',
    list: [
      {
        title: 'Clinical Applications',
        des: ['AneuPlan assists the interventional planning and the device selection in a hemodynamic way before surgery. According to the characteristics of the aneurysm of a specific patient, the blood flow changes after different intervention plans can be quantified and assist formulating the best treatment plan.'],
        img: require('@/assets/images/innovate/AneuPlan/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: 'Individualized and precise treatment',
            list: [
              'Meets the treatment needs of different scenarios and provides the best treatment plan',
              'Personalized surgical planning according to the characteristics of aneurysms',
              'Provides precise treatment',
              'Reduces the risk of treatment and improves the prognosis of aneurysm'
            ]
          }, {
            title: 'Original technology applications',
            list: [
              'Fast finite element method for virtual treatment',
              'Precise release of coils, stents, flow diverters and endosaccular flow disruption',
              'Comparision between various plans for the best solution',
              'Assists clinical decision-making through quantified hemodynamic parameters'
            ]
          }
        ],
        img: require('@/assets/images/innovate/AneuPlan/en/2.png'),
        imgBj: require('@/assets/images/innovate/AneuPlan/3.png')
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Xiang J, Ma D, Snyder KV, Levy EI, Siddiqui AH, Meng H. Increasing Flow Diversion for Cerebral Aneurysm Treatment Using a Single Flow Diverter. Neurosurgery 2014; 75: 286–294',
        'Xiang J, Damiano RJ, Lin N, et al. High-fidelity virtual stenting: modeling of flow diverter deployment for hemodynamic characterization of complex intracranial aneurysms. JNS 2015; 123: 832–840',
        'Leng X, Wan H, Li G, et al. Hemodynamic effects of intracranial aneurysms from stent-induced straightening of parent vessels by stent-assisted coiling embolization. Interv Neuroradiol 2021; 27: 181–190',
        'Zhang M, Tian Z, Zhang Y, et al. How to perform intra-aneurysmal coil embolization after Pipeline deployment: a study from a hemodynamic viewpoint. J Neurointerv Surg 2023; 15: 157–162'
      ]
    }
  },
  aneuguide: {
    title: '<i class="p-r-6">AneuGuide</i> | Intracranial Aneurysm Interventional Planning',
    name: '脑血管智能诊疗解决方案',
    type: 'AneuGuide',
    list: [
      {
        title: 'Clinical Applications',
        des: [
          'AneuGuide enables visualization ofintracranial vessels for preoperational planning and sizing for neurovascular interventions. Advanced algorithm and unique dual-view design facilitate the comparison between different flow diverter devices, which makes the software a useful tool for selecting the appropriate size. The quantitative parameters include apposition, metal coverage ratio and pore density, offering an informative reference for medical professionals.',
          'Aproved by CN NMPA and cleared by US FDA 510(k).'
        ],
        img: require('@/assets/images/innovate/AneuGuide/en/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: 'Fast and accurate surgical planning',
            list: ['93.4% accuracy in predicting the length of FD <sup class="color_active">[1]</sup>', 'Real-time FD dragging display to view the change of metal coverage, apposition, pore density and other parameters', 'The analysis is completed in 3 minutes, assisting the doctor to select the optimal stent type and make the optimal surgical plan']
          }, {
            title: 'Original virtual simulation technology',
            list: [
              'Solves the challenges of time-consuming, low accuracy and hard to locate accurately in traditional method',
              'Provides fast and accurate solution for the selection of stent type and location optimization of FD',
              'Improves the interventional surgery outcome and reduce consumables waste and cost expenditure'
            ]
          }
        ],
        img: require('@/assets/images/innovate/AneuGuide/en/2.png'),
        imgBj: require('@/assets/images/innovate/AneuGuide/3.png')
      }, {
        title: 'Meet Clinical Needs',
        des: [
          {
            des: 'Excellent clinical tool for real-time guidance on FD placement, sizing and slight adjustment during interventional surgery',
            img: require('@/assets/images/innovate/AneuGuide/3_1.png')
          }, {
            des: 'Accurate positioning and sizing, no repeated adjustment and consumption of mismatched consumables',
            img: require('@/assets/images/innovate/AneuGuide/3_2.png')
          }, {
            des: 'Low risk, real-time, excellent clinical effect, significantly reduced the patient costs and improve the treatment success rate',
            img: require('@/assets/images/innovate/AneuGuide/3_3.png')
          }
        ]
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Tong X, Shan Y, Leng X, et al. Predicting flow diverter sizing using the AneuGuide<sup>&trade;</sup> software: a validation study. J Neurointerv Surg 2023; 15: 57–62'
      ]
    }
  },
  aneushape: {
    title: '<i class="p-r-6">AneuShape</i> | Intracranial Aneurysm Microcatheter Shaping',
    name: '脑血管智能诊疗解决方案',
    type: 'AneuFlow',
    list: [
      {
        title: 'Clinical Applications',
        des: ['AneuShape visualizes the virtual microcatheter in combination with the 3D vessel model path based on mathematical modeling and image algorithm. The morphology of the shaping needle is generated based on the rebound coefficient of the microcatheter, providing neurointerventional surgeons with the optimal planning for microcatheter shaping in the process of coil embolization.'],
        img: require('@/assets/images/innovate/AneuShape/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: 'Widely applicable',
            list: [
              'Compatible with various types of microcatheter',
              '3D shaping results visualization',
              'Combining intelligent diagnosis and treatment with personalized analysis'
            ],
            img: require('@/assets/images/innovate/AneuShape/2_1.png')
          }, {
            title: 'Fast and precise',
            list: [
              'Intelligent microcatheter shaping in three minutes',
              'Multiple shaping parameters for precise shaping',
              'Virous shaping results to choose for surgical plan optimization'
            ],
            img: require('@/assets/images/innovate/AneuShape/2_2.png')
          }
        ],
        img: require('@/assets/images/innovate/AneuShape/2.png')
      }, {
        title: 'Quick microcatheter shaping',
        img: require('@/assets/images/innovate/AneuShape/en/3.png'),
        m_img: require('@/assets/images/innovate/AneuShape/en/m_3.png')
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Wu ZB, Zeng Y, Zhang HQ, et al. Virtual simulation with AneuShape<sup>&trade;</sup> software for microcatheter shaping of intracranial aneurysm coiling: a validation study. Frontiers in Neurology. 2023'
      ]
    }
  },
  accuaspects: {
    title: '<i>AccuASPECTS</i> | Automated Calculation of ASPECTS',
    name: '脑血管智能诊疗解决方案',
    type: 'AccuASPECTS',
    list: [
      {
        title: 'Clinical Applications',
        des: ['AccuASPECT automatically partitions the brain and identifies if ischemic changes are occurring in each region, and automatically calculates the ASPECT score.'],
        img: require('@/assets/images/innovate/AccuASPECTS/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: 'Automated Extreme Analysis',
            list: [
              'Automated ASPECT scoring based on non-contrast CT (NCCT) image data',
              'Automated corrects motion deviation, partitions the brain and calculates early ischemic changes'
            ],
            img: require('@/assets/images/innovate/AccuASPECTS/2_1.png')
          }, {
            title: 'Fast assessment',
            list: [
              'Ischemic strokes require time-critical diagnosis and treatment to avoid rapid deterioration',
              'Compared to the time-consuming manual reading of each area for assessment',
              "Quickly automates the scoring of a patient's middle cerebral artery (MCA) blood supply area"
            ],
            img: require('@/assets/images/innovate/AccuASPECTS/2_2.png')
          }, {
            title: 'Exclusive machine learning algorithm support',
            list: [
              'Differences in imaging equipment, patient condition and subjectivity of the reviewer make the manual review method lack stability',
              'AccuASPECTS can output stable results without subjective interference'
            ],
            img: require('@/assets/images/innovate/AccuASPECTS/2_3.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuASPECTS/en/2.png')
      }, {
        title: 'Reliable Automated Result',
        des: [''],
        img: require('@/assets/images/innovate/AccuASPECTS/3.png')
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Wan S, Lu W, Fu Y, et al. Automated Calculation of the Alberta Stroke Program Early CT Score based on Large Cohort of Data and Machine Learning. European Radiology 2023'
      ]
    }
  },
  accuctp: {
    title: '<i class="p-r-6">AccuCTP</i> | Intracranial CT Perfusion Analysis',
    name: '脑血管智能诊疗解决方案',
    type: 'AccuCTP',
    list: [
      {
        title: 'Clinical Applications',
        des: [
          'AccuCTP is a powerful clinical tool for analyzing the intracranial CT perfusion image. Fast generation ofparameter maps and volumetry of multi-threshold can clearly represent the changes of brain tissue perfusion. AccuCTP allows viewing, quantification, analysis and reporting capabilities and provides accurate evaluationresult efficiently for clinicians.',
          'Received US FDA 510(k) clearance and CN NMPA approval.'
        ],
        img: require('@/assets/images/innovate/AccuCTP/en/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: 'Efficient Analysis',
            list: ['Analysis within 2 minutes, improving stroke diagnosis efficiency', 'Automated data transmission and reports delivery', 'Real-time tandem image analysis and clinical treatment'],
            img: require('@/assets/images/innovate/AccuCTP/icon1.png')
          }, {
            title: 'Intelligent Assessment',
            list: ['90% accuracy rate of quantitative assessment results', 'Breaking the traditional method of image reading to analyze brain tissue ischemia quantitatively', 'Focus on the “ischemic penumbra” to improve patient prognosis'],
            img: require('@/assets/images/innovate/AccuCTP/icon2.png')
          }, {
            title: 'Wide range of applications',
            list: ['Standard and user-friendly GUI', 'Balance between automated processes and personalized analysis', 'Integrated clinical application and scientific research'],
            img: require('@/assets/images/innovate/AccuCTP/icon3.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuCTP/2.png')
      }, {
        title: 'Smooth data transmission',
        img: require('@/assets/images/innovate/AccuCTP/en/3.png')
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Lu W, Yao F, Yin C, et al. Assessment of Parameter Maps and Ischemic  Volumes with Different CT Perfusion Software：A Comparative Study. Neuroradiology 2023'
      ]
    }
  },
  accufficas: {
    title: '<i class="p-r-6">AccuICAS</i> | Intracranial Stenosis Functional Assessment',
    name: '脑血管智能诊疗解决方案',
    type: 'AccuICAS',
    list: [
      {
        title: 'Clinical Applications',
        des: [
          'AccuICAS is designed for evaluating the intracranial stenosis based on medical images. Fast vascular 3D reconstruction is provided and advanced hemodynamic method is used for calculating the hemodynamic parameters of intracranial vessels.',
          'Received US FDA 510(k) clearance.'
        ],
        img: require('@/assets/images/innovate/AccuFFicas/en/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: 'Flexible',
            list: [
              'High adaptability,available for 3D reconstruction of 3D and 2D DSA, CTA, and MRA',
              'Strong operability, accurate visualization of lesion location and stenosis'
            ],
            img: require('@/assets/images/innovate/AccuFFicas/icon1.png')
          }, {
            title: 'Real-time',
            list: [
              'Complete analysis in 5 minutes',
              'Automate the entire process from diagnosis to reporting'
            ],
            img: require('@/assets/images/innovate/AccuFFicas/icon2.png')
          }, {
            title: 'Accurate',
            list: [
              'High fidelity vessel models by 3D reconstruction based on medical images',
              'Hemodynamic parameters of ICAS for accurate assessment'
            ],
            img: require('@/assets/images/innovate/AccuFFicas/icon3.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuFFicas/2.png')
      }, {
        title: 'Accurate assessment of arterial stenosis and atherosclerosis',
        img1: require('@/assets/images/innovate/AccuFFicas/3_1.png'),
        img2: require('@/assets/images/innovate/AccuFFicas/3_2.png'),
        m_imgDes: 'solving the problem of high incidence of arterial stenosis in Chinese people'
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Wang M, Leng X, Wu J, et al. Cerebral Fractional Flow Reserve for Functional Evaluation of Intracranial Atherosclerotic Stenosis. Transl Stroke Res 2022; published online May 30',
        'Wang M, Leng X, Mao B, et al. Functional evaluation of intracranial atherosclerotic stenosis by pressure ratio measurements. Heliyon 2023; 9: e13527',
        'Yang P, Wan S, Wang J, et al. Hemodynamic Assessment for Intracranial Atherosclerosis from Angiographic Images: A Clinical Validation Study. J Neurointerv Surg 2023'
      ]
    }
  },
  accuffrct: {
    title: 'AccuFFRct | CTA-derived non-invasive FFR',
    name: '心血管智能诊疗解决方案',
    type: 'AccuFFRct',
    list: [
      {
        title: 'Clinical Applications',
        des: [
          "The CTA functional analysis system evaluates the functional status of coronary arteries based on AI and hemodynamics. By reconstructing the coronary trees from CTA imaging and combining patient's physiological information with hemodynamic calculations, the system provides parameters for the functional assessment of coronary stenosis.",
          'Unlike conventional invasive FFR measurements, CTA-based FFR technology uses a self-developed calculation model that can quickly and accurately calculate the FFR distribution of the entire coronary tree, and identify patients at risk. Currently, AccuFFRct system has received EU CE approval, and CN NMPA approval.'
        ],
        img: require('@/assets/images/innovate/AccuFFRct/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: ['Deep learning-based coronary', 'artery reconstruction '],
            list: ['Automatic intelligent image post-processing', 'Coronary tree reconstruction in 20 s, with whole analysis completion in 3 min'],
            img: require('@/assets/images/innovate/AccuFFRct/2_1.png')
          }, {
            title: ['Rapid hemodynamic calculation'],
            list: ['Compared to wire-based FFR, AccuFFRct achieved an accuracy of 91.8% <sup class="color_active">[1]</sup>', 'On-site calculation and reporting without data transmission'],
            img: require('@/assets/images/innovate/AccuFFRct/2_2.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuFFRct/2.png')
      }, {
        title: 'Product Advantages',
        des: [
          {
            title: 'Accurate and non-invasive',
            list: ['High accuracy is retained for calcified lesions and “gray zone” lesions', 'Rapid screening based on non-invasive functional assessment'],
            img: require('@/assets/images/innovate/icons/6_big.png')
          }, {
            title: 'Fast and efficient',
            list: ['Real-time evaluation report', 'Rapid synchronization of results according to clinical needs'],
            img: require('@/assets/images/innovate/icons/7_big.png')
          }, {
            title: 'Comprehensive assessment',
            list: ['Accurate 3D simulation and hemodynamic analysis', 'FFR values can be obtained at any site of coronary arteries from CTA along'],
            img: require('@/assets/images/innovate/icons/8_big.png')
          }, {
            title: 'Economical and safe',
            list: ['Routine CTA examination, no additional radiation, no pain', 'Reduce medical cost and avoid unnecessary intervention'],
            img: require('@/assets/images/innovate/icons/9_big.png')
          }
        ]
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Jiang J, Du C, Hu Y, et al. Diagnostic performance of computational fluid dynamics (CFD)-based fractional flow reserve (FFR) derived from coronary computed tomographic angiography (CCTA) for assessing functional severity of coronary lesions. Quant Imaging Med Surg 2023; 13: 1672–85',
        'Zhang J, Xu K, Hu Y, et al. Diagnostic performance of deep learning and computational fluid dynamics-based instantaneous wave-free ratio derived from computed tomography angiography. BMC Cardiovasc Disord 2022; 22: 33',
        'Jiang W, Pan Y, Hu Y, et al. Diagnostic accuracy of coronary computed tomography angiography-derived fractional flow reserve. Biomed Eng Online 2021; 20: 77'
      ]
    }
  },
  accuffrangio: {
    title: 'AccuFFRangio | angiography-derived FFR',
    name: '心血管智能诊疗解决方案',
    type: 'AccuFFRangio',
    list: [
      {
        title: 'Clinical Applications',
        des: ['This wire-free coronary functional evaluation system can perform fast and accurate quantitative analysis of myocardial ischemia by 3D reconstruction and FFR calculation from routine coronary angiography. The system can also guide precise treatment and optimize coronary intervention. In addition, the system is currently the only product that has received US FDA 510(k) clearance, EU CE approval, and CN NMPA approval.'],
        img: require('@/assets/images/innovate/AccuFFRangio/en/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: ['Pre-procedural Functional', 'Assessment'],
            list: [
              'No consumables required',
              'Assisting clinical diagnosis of culprit lesions',
              'Achieving exact anatomical lesion quantification',
              'Obtaining higher diagnostic accuracy than conventional imaging assessment'
            ],
            img: require('@/assets/images/innovate/icons/10_en.png')
          }, {
            title: ['Post-procedural', 'Functional Evaluation'],
            list: [
              'Comparison before and after surgery',
              'Quantitative evaluation of PCI treatment',
              'Evidence-based medical report for doctor-patient communication'
            ],
            img: require('@/assets/images/innovate/icons/12_en.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuFFRangio/2.png'),
        m_img: require('@/assets/images/innovate/AccuFFRangio/m_2.png')
      }, {
        title: 'Product Advantages',
        des: [
          {
            title: 'Time- and Cost-saving',
            list: ['No need for pressure wire and adenosine, user-friendly', 'Reaching 32%  higher sensitivity than similar products<sup class="color_active">[1]</sup>'],
            img: require('@/assets/images/innovate/icons/9_big.png')
          }, {
            title: 'Convenient Diagnosis',
            list: ['Editable structured reports', 'Personalized medical institution info and clinical opinions', 'Simple, safe, efficient and intuitive workflow'],
            img: require('@/assets/images/innovate/icons/7_big.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuFFRangio/en/3.png'),
        imgDes: 'Diagnostic accuracy of AccuFFRangio reached 93.3%, pioneering the era of wire-free FFR evaluation.'
      }, {
        title: 'More Functions to Meet Clinical Needs',
        des: [
          'Achieving Rapid quantitative analysis of myocardial ischemia by computed FFR based on coronary angiography alone',
          'Avoiding the utilization of a temperature/pressure wire and reducing patient pain and costs',
          'Overcoming the suboptimal accuracy of past anatomical assessment'
        ]
      }, {
        title: 'What’s <span class="color_err">New</span> in AccuFFRangio 2.0*',
        des: [
          {
            title: 'Multi-Vessel Reconstruction',
            des: ['Achieving FFR value in each branch vessel', 'Accessing the impact of branch vessel on myocardial ischemia'],
            img: require('@/assets/images/innovate/AccuFFRangio/en/4_1.png')
          }, {
            type: 'all',
            img: require('@/assets/images/innovate/AccuFFRangio/en/4.png')
          }, {
            title: 'Treatment Planning',
            des: ['Quantitative analysis of hemodynamic loss (△AccuFFRangio) across lesions', 'Automatic Simulation of hemodynamic changes after stent implantation', 'Accurate and reliable PCI planning technology in stent selection and stent positioning'],
            img: require('@/assets/images/innovate/AccuFFRangio/en/4_2.png')
          }, {
            title: 'Microcirculation Evaluation',
            des: ['One-step evaluation of macrovascular and microvascular disease', 'Microcirculation evaluation assisting prognosis management'],
            img: require('@/assets/images/innovate/AccuFFRangio/en/4_3.png')
          }
        ],
        sign: 'This multi-vessel reconstruction/treatment planning/microcirculation evaluation function does not have CE/FDA clearance, is only used for research.'
      }, {
        title: 'More Product Information',
        des: 'If you want to know more about the product or get the product manual, please click here',
        img: require('@/assets/images/innovate/arrow.png'),
        btn: 'Product Consultation',
        dialog: {
          img: require('@/assets/images/innovate/dialog.png'),
          title: 'Product Consultation',
          form: {
            lastName: {
              label: 'Last Name',
              placeholder: 'Please input…',
              required: ['This field must be filled!']
            },
            firstName: {
              label: 'First Name',
              placeholder: 'Please input…',
              required: ['This field must be filled!']
            },
            email: {
              label: 'E-mail Address',
              placeholder: 'Please input…',
              required: ['This field must be filled!', 'E-mail error']
            },
            institutionName: {
              label: 'Institution Name',
              placeholder: 'Please input…',
              required: ['This field must be filled!']
            },
            profession: {
              label: 'Profession',
              placeholder: 'Please Select',
              required: ['Please select']
            },
            product: {
              label: 'Interested Product',
              placeholder: 'Please input…',
              required: ['This field must be filled!']
            }
          },
          formData: {
            profession: {
              physician: { name: 'Doctor', value: '医师' },
              technician: { name: 'Technician', value: '医学技师' },
              scientificResearch: { name: 'Researcher', value: '科研人员' },
              other: { name: 'Others', value: '其他' }
            }
          },
          privacyPolicy: [
            'Read more in the ',
            'Privacy Policy'
          ],
          btn: {
            title: 'Submit',
            success: 'Submitted Successfully'
          }
        }
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        // 'Li, C., Leng, X., He, J., Xia, Y., Jiang, W., Pan, Y., Dong, L., Sun, Y., Hu, X., Wang, J., Xiang, J., & Jiang, J. (2021). Diagnostic Performance of Angiography-Based Fractional Flow Reserve for Functional Evaluation of Coronary Artery Stenosis. Frontiers in Cardiovascular Medicine, 8(714077). https://doi.org/10.3389/fcvm.2021.714077',
        'Jiang, J., Tang, L., Du, C., Leng, X., He, J., Hu, Y., Dong, L., Sun, Y., Li, C., Xiang, J., & Wang, J. (2022). Diagnostic performance of AccuFFRangio in the functional assessment of coronary stenosis compared with pressure wire-derived fractional flow reserve. Quantitative Imaging in Medicine and Surgery, 12(2), 949–958. https://doi.org/10.21037/qims-21-463'
      ]
    }
  },
  accuffrivus: {
    title: '<i class="p-r-6">AccuFFR</i><i>ivus</i> | IVUS-derived FFR',
    name: '心血管智能诊疗解决方案',
    type: 'AccuFFRIVUS',
    list: [
      {
        title: 'Clinical Applications',
        des: ['AccuFFRivus is a wire-free method to calculate FFR for identifying functional significant coronary stenosis based on the fusion of IVUS images and angiographic images.'],
        img: require('@/assets/images/innovate/AccuFFRivus/1.png')
      }, {
        title: 'Product Features',
        img: require('@/assets/images/innovate/AccuFFRivus/en/2.png'),
        m_img: require('@/assets/images/innovate/AccuFFRivus/en/m_2.png')
      }, {
        title: '',
        des: [
          {
            title: ['High-precision automatic', 'lumen segmentation'],
            list: [
              'DeepIVUS technology for high-precision automatic segmentation.',
              'An accuracy of 0.937 for IVUS lumen segmentation',
              'Assisting coronary artery wall and plaque analysis'
            ],
            img: require('@/assets/images/innovate/AccuFFRivus/icon1.png')
          }, {
            title: ['Deep learning powered IVUS', 'image reconstruction'],
            list: [
              'An accuracy of 96% using the self-developed deep learning neural segmentation network<sup class="color_active">[1]</sup>',
              'One IVUS measurement formorphological characteristics and functional evaluation',
              'Eliminate the issue of high medical cost by the need of two consumables in IVUS measurement and FFR evaluation'
            ],
            img: require('@/assets/images/innovate/AccuFFRivus/icon2.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuFFRivus/2.png'),
        m_img: require('@/assets/images/innovate/AccuFFRivus/m_2.png')
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Jiang J, Feng L, Li C, et al. Fractional flow reserve for coronary stenosis assessment derived from fusion of intravascular ultrasound and X-ray angiography. Quant Imaging Med Surg 2021; 11: 4543–55',
        'Dong L, Jiang W, Lu W, et al. Automatic segmentation of coronary lumen and external elastic membrane in intravascular ultrasound images using 8-layer U-Net. Biomed Eng Online 2021; 20: 16'
      ]
    }
  },
  accuffroct: {
    title: '<i class="p-r-6">AccuFFR</i><i>oct</i> | OCT-derived FFR ',
    name: '心血管智能诊疗解决方案',
    type: 'AccuFFROCT',
    list: [
      {
        title: 'Clinical Applications',
        des: ['AccuFFRoct is a wire-free method to calculate FFR in identification of functional severe stenosis based on OCT images combined with angiographic images. AccuFFRoct has received CN NMPA approval.'],
        img: require('@/assets/images/innovate/AccuFFRoct/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: 'Precise, multimodal 3D reconstruction',
            list: ['3D reconstruction of the target vessel based on OCT images and angiography images', 'Quickly and accurately provide lesion-specific morphological information', 'Improve clinical diagnosis efficiency'],
            img: require('@/assets/images/innovate/AccuFFRoct/2.png')
          }, {
            title: 'Intravascular OCT images combined with angiographic images',
            list: ['Intravascular morphological characteristics and functional evaluation indexes can be obtained simultaneously with a single OCT measurement', 'Eliminate the issue of high medical cost by the need of double instrumentations in OCT measurement and FFR evaluation'],
            img: require('@/assets/images/innovate/AccuFFRoct/en/3.png')
          }
        ]
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Pan W, Wei W, Hu M, et al. Diagnostic accuracy of a novel optical coherence tomography based fractional flow reserve algorithm for assessment of coronary stenosis significance. Cardiology Journal 2023'
      ]
    }
  },
  acculv: {
    title: '<i class="p-r-14">AccuLV</i> | Non-invasive evaluation of cardiac function',
    m_title: '<i class="p-r-6">AccuLV</i> | Non-invasive evaluation of cardiac function',
    name: '心血管智能诊疗解决方案',
    type: 'AccuLV',
    list: [
      {
        title: 'Clinical Applications',
        des: ['AccuLV can perform left ventricular segmentation based on CCTA images and extract the contours of the endocardium and epicardium of the left ventricle. It can calculate the left ventricular end-diastolic and end-systolic volume, and the ejection fraction. AccuLV can assist in the clinical diagnosis of cardiac function.'],
        img: require('@/assets/images/innovate/AccuLV/1.png')
      }, {
        title: 'Product Features',
        des: [
          {
            title: ['Cardiac CT segmentation', 'powered by deep learning'],
            list: ['Achieve precise segmentation by integrating AI technologies, such as intelligent image processing and deep learning', 'With Dice similarity coefficient of LV segmentation reaches 0.927, which can provide accurate cardiac functional characteristics'],
            img: require('@/assets/images/innovate/AccuLV/2_1.png')
          }, {
            title: ['Comprehensive evaluation combining', 'imaging and functional analysis'],
            list: ['Rapid and high-precision 3D reconstruction of the left ventricle by using self-developed AI segmentation technique', 'Calculating cardiac functional characteristics and bullseye plot simultaneously for rapid screening of patients with potential cardiac dysfunction'],
            img: require('@/assets/images/innovate/AccuLV/2_2.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuLV/2.png')
      }, {
        title: 'Product Advantages',
        des: [
          {
            title: 'Efficient',
            list: ['Complete the calculation in 2 min'],
            img: require('@/assets/images/innovate/icons/7_big.png')
          }, {
            title: 'Precise',
            list: ['AI-powered LV segmentation achieves a precision of 0.938<sup class="color_active">[1]</sup>'],
            img: require('@/assets/images/innovate/icons/6_big.png')
          }, {
            title: 'Economical',
            list: ['Based on Coronary CTA, non-invasive, cost-effective and time-saving'],
            img: require('@/assets/images/innovate/icons/9_big.png')
          }, {
            title: 'Intelligent',
            list: ['Automatic AI segmentation, rapid processing, excellent reproducibility'],
            img: require('@/assets/images/innovate/icons/15_big.png')
          }
        ],
        img: require('@/assets/images/innovate/AccuLV/3.png'),
        imgDes: 'Bullseye plot analysis'
      }
    ],
    article: {
      title: 'Reference:',
      des: [
        'Li C, Song X, Zhao H, et al. An 8-layer residual U-Net with deep supervision for segmentation of the left ventricle in cardiac CT angiography. Comput Methods Programs Biomed 2021; 200: 105876'
      ]
    }
  },
  accuimr: {
    // title: '<i class="p-r-10">AccuIMR</i> | Coronary microcirculation resistance index analysis software based on invasive coronary angiography',
    title: '<i class="p-r-15">AccuIMR</i> | ',
    des: ['Coronary microcirculation resistance index analysis software', 'based on invasive coronary angiography'],
    name: '心血管智能诊疗解决方案',
    type: 'AccuIMR',
    list: [
      {
        title: 'Clinical Applications',
        des: ['The functional evaluation system for coronary microcirculation can perform rapid 3D reconstruction of coronary arteries and calculate the index of microcirculation resistance based on 2 angiographic views. AccuIMR can quantitatively assess coronary microvascular disease and guide therapeutic strategies.', 'In Januray 2023, AccuIMR was approved for the Special Review for China Class III Innovative Medical Devices by the CN NMPA.'],
        img: require('@/assets/images/innovate/AccuIMR/en/1.png')
      }, {
        title: 'Product Advantages',
        des: [
          {
            title: 'Time- and cost-saving',
            list: [['No need to use consumables such as pressure-wire'], ['Based on conventional coronary angiography alone'], ['Complete the calculation and evaluation in 5 min'], ['Improve clinical diagnosis efficiency']]
          }, {
            title: 'Convenient comprehensive diagnosis',
            list: [['Simple, explicit, safe, semi-automated workflow'], ['Intuitive structured reporting'], ['Combined with DSA, it is possible to perform one-stop functional evaluation of coronary microciroulation']]
          }
        ],
        img: require('@/assets/images/innovate/AccuIMR/2.png'),
        img1: require('@/assets/images/innovate/AccuIMR/2_1.png')
      }, {
        title: 'Clinical Validation',
        list: [
          {
            title: 'Accuracy',
            num: 93.83,
            unit: '%'
          }, {
            title: 'Sensitivity',
            num: 93.65,
            unit: '%'
          }, {
            title: 'Specificity',
            num: 92.31,
            unit: '%'
          }
        ],
        des: 'AccuIMR has demonstrated high feasibility and good diagnostic performance, it can provide clinicians with an accurate and quantitative functional assessment information of the microcirculation. In current clinical practice, FFR is considered the gold standard for PCI guidance, AccuIMR can be used as an valuable tool for better risk stratification and patient management, leading to improved prognosis.'
      }
    ],
    moreInformation: {
      title: 'More Product Information',
      des: 'If you want to know more about the product or get the product manual, please click here',
      img: require('@/assets/images/innovate/arrow.png'),
      btn: 'Product Consultation',
      dialog: {
        img: require('@/assets/images/innovate/dialog.png'),
        title: 'Product Consultation',
        form: {
          lastName: {
            label: 'Last Name',
            placeholder: 'Please input…',
            required: ['This field must be filled!']
          },
          firstName: {
            label: 'First Name',
            placeholder: 'Please input…',
            required: ['This field must be filled!']
          },
          email: {
            label: 'E-mail Address',
            placeholder: 'Please input…',
            required: ['This field must be filled!', 'E-mail error']
          },
          institutionName: {
            label: 'Institution Name',
            placeholder: 'Please input…',
            required: ['This field must be filled!']
          },
          profession: {
            label: 'Profession',
            placeholder: 'Please Select',
            required: ['Please select']
          },
          product: {
            label: 'Interested Product',
            placeholder: 'Please input…',
            required: ['This field must be filled!']
          }
        },
        formData: {
          profession: {
            physician: { name: 'Doctor', value: '医师' },
            technician: { name: 'Technician', value: '医学技师' },
            scientificResearch: { name: 'Researcher', value: '科研人员' },
            other: { name: 'Others', value: '其他' }
          }
        },
        privacyPolicy: [
          'Read more in the ',
          'Privacy Policy'
        ],
        btn: {
          title: 'Submit',
          success: 'Submitted Successfully'
        }
      }
    },
    article: {
      title: 'Reference:',
      des: [
        'Fan Y, Li C, Hu Y, et al. Angiography-Based Index of Microcirculatory Resistance (AccuIMR) for the Assessment of Microvascular Dysfunction in Acute Coronary Syndromes and Chronic Coronary Syndromes. Quant Imaging Med Surg 2023'
      ]
    }
  },
  accuvalve: {
    title: '',
    name: '心血管智能诊疗解决方案',
    type: 'AccuVALVE'
  }
}

export default product
